// app/javascript/controllers/timer_controller.js
import {Controller} from "@hotwired/stimulus"

// Phrase progressions per *context mode*. The server sets data-phrase-mode on
// the phrase span based on what the agent is doing right now; JS rotates within
// the matching set based on elapsed wall-clock time. This keeps the wording
// honest — "Digging deeper…" only appears when the agent really is digging
// deeper (multiple tools or long elapsed), not the moment it starts.
const PHRASE_SETS = {
  initial: [
    { at: 0, text: "Thinking…" },
    { at: 4, text: "Reasoning through it…" }
  ],
  between: [
    { at: 0,  text: "Still thinking…" },
    { at: 8,  text: "Considering options…" },
    { at: 20, text: "Working through it…" }
  ],
  deep: [
    { at: 0,  text: "Digging deeper…" },
    { at: 15, text: "Exploring more…" },
    { at: 30, text: "Thinking deeper…" },
    { at: 50, text: "Almost there…" },
    { at: 70, text: "Refining the answer…" }
  ]
}

export default class extends Controller {
  static targets = ["display", "phrase"]

  connect() {
    this.startTime  = Date.now()
    this.running    = true
    this.lastPhrase = null
    this.updateDisplay()
    this.intervalId = setInterval(() => { if (this.running) this.updateDisplay() }, 200)
  }

  updateDisplay() {
    const elapsedSec = (Date.now() - this.startTime) / 1000

    if (this.hasDisplayTarget) {
      this.displayTarget.textContent = `${elapsedSec.toFixed(1)}s`
    }

    if (this.hasPhraseTarget && this.phraseTarget.dataset.serverPhrase !== "true") {
      const mode = this.phraseTarget.dataset.phraseMode || "initial"
      const set  = PHRASE_SETS[mode] || PHRASE_SETS.initial
      let chosen = set[0].text
      for (const p of set) { if (elapsedSec >= p.at) chosen = p.text }
      if (chosen !== this.lastPhrase) {
        this.phraseTarget.textContent = chosen
        this.lastPhrase = chosen
      }
    }
  }

  stop() {
    this.running = false
    if (this.intervalId) { clearInterval(this.intervalId); this.intervalId = null }
    this.updateDisplay()
  }

  disconnect() { this.stop() }
}
